export default function bytesToMega(sizeInBytes) {
  const sizeInMB = (sizeInBytes / (1024 * 1024)).toFixed(2);
  return sizeInMB + "MB";
}
